<template>
  <div class="flex flex-col md:flex-row -mx-4">
    <div class="flex-1 px-4 mb-2 md:mb-0">
      <h1 class="campaign-preamble-title inline">
        {{ campaign.topic }}
      </h1>
      <div
        v-if="campaign.html"
        class="inline"
      >
        <div
          class="campaign-preamble inline"
          :data-translation="campaign?.html_translationkey"
          v-html="campaign.html"
        />
      </div>
    </div>

    <div
      v-if="uspList.length"
      class="w-full md:w-1/3 px-4"
    >
      <div
        class="bg-dirty-blue size-full pt-6 pb-8 px-4 rounded-lg"
      >
        <strong class="text-2xl block">
          {{ campaign.usp_header }}
        </strong>
        <div
          v-for="(usp, idx) in uspList"
          :key="idx"
          class="font-secondary mt-4 text-base"
        >
          <strong v-if="usp.label">
            {{ usp.label }} -
          </strong>
          <span>
            {{ usp.text }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  campaign: {
    type: Object,
    required: true,
  },
})

const uspList = computed(() => (props.campaign.usp_header && props.campaign.usp_list)
  ? props.campaign.usp_list.split('\r').map((usp) => {
    const [label, text] = usp.includes(':')
      ? usp.split(':')
      : ['', usp]

    return {
      label: label?.trim() || '',
      text: text || '',
    }
  })
  : []
)
</script>

<style lang="scss">
// Chunk of HTML from Filemaker, hence no helper classes
/*! purgecss start ignore */
.campaign-preamble {
  &-title {
    @apply text-[28px] font-extrabold font-primary;
  }

  & > h1:first-child {
    display: inline;

    &::before {
      content: ' – ';
    }
  }

  h1, h2, h3 {
    @extend .campaign-preamble-title;
  }

  p {
    @apply mt-2 md:mt-3;
    font-family: theme('fontFamily.secondary');
  }

  p,
  strong,
  b {
    @apply text-lg;
  }

  li {
    font-family: theme('fontFamily.secondary');
  }
}
/*! purgecss end ignore */
</style>